import type { PillMarkViewModel } from "./types-gantt";

export function PillMarkView({
  slotClassName,
  pillClassName,
  contentClassName,
  style,
  align,
  tone,
  dataPast,
  testId,
  slotTestId,
  children,
  rest,
}: PillMarkViewModel) {
  return (
    <div
      className={slotClassName}
      style={style}
      data-align={align}
      data-tone={tone}
      data-past={dataPast}
      data-testid={slotTestId}
      {...rest}
    >
      <span className={pillClassName} data-tone={tone} data-testid={testId}>
        <span className={contentClassName}>{children}</span>
      </span>
    </div>
  );
}
